import { boot, store } from "quasar/wrappers";
import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";

import { axiosInstance } from "./axios";
import { API_ENDPOINTS } from "src/constants/api-endpoints";
import { Cookies } from "quasar";
import mitt from "mitt";

const pinia = createPinia();
export default boot(({ app }) => {
  // You can add Pinia plugins here
  // pinia.use(SomePiniaPlugin)
  const emitter = mitt();
  app.use(pinia);
  app.config.globalProperties.emitter = emitter;
});

export { pinia };
